// src/store/premiumSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface PremiumState {
    /** Webhook 反映までの一時プレミアム状態 */
    temporaryPremium: boolean;
}

const initialState: PremiumState = {
    temporaryPremium: false
};

const premiumSlice = createSlice({
    name: 'premium',
    initialState,
    reducers: {
        setTemporaryPremium: (state, action: PayloadAction<boolean>) => {
            state.temporaryPremium = action.payload;
        },
        clearTemporaryPremium: (state) => {
            state.temporaryPremium = false;
        }
    }
});

export const { setTemporaryPremium, clearTemporaryPremium } = premiumSlice.actions;
export default premiumSlice.reducer;
